export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13558.eaba91ab.jpg";